import { VoiceModel } from "@/actions/db/get-models";
import { AutoSizer, Grid, GridCellRenderer } from "react-virtualized";
import styles from "./virtualized-voices-grid.module.scss";
import { ScrollParams } from "react-virtualized/dist/es/Grid";
import React from "react";
import { useMobile } from "@/hooks/use-responsive";
import VirtualizedVoiceCard from "@/components/pages/home/components/voices/virtualized-voice-card";

export interface VirtualizedVoicesGridProps {
  voiceList: VoiceModel[];
  handleVoiceModelClick: (model: VoiceModel) => void;
  onScroll?: (scrollTop: number | undefined) => void;
  needsEmptySpace: boolean;
}

/**
 * Virtualized grid for voices.
 * Should change width and height properties here also if card style will be changed because virtualization need a tsx sizes set.
 */
const VirtualizedVoicesGrid = ({
  voiceList,
  handleVoiceModelClick,
  onScroll,
  needsEmptySpace,
}: VirtualizedVoicesGridProps) => {
  const { isMobile } = useMobile();

  const minColumnWidth = isMobile ? 164 : 228;
  const rowHeight = 215;
  const mobileEmptyBottomSpace = needsEmptySpace ? 207 : 40;
  const desktopEmptyBottomSpace = needsEmptySpace ? 50 : 0;

  const handleScroll = (params: ScrollParams) => {
    if (onScroll) {
      onScroll(params.scrollTop);
    }
  };

  return (
    <AutoSizer disableHeight={isMobile} className={styles.wrapper}>
      {({ height, width }) => {
        const columnCount = Math.max(1, Math.floor(width / minColumnWidth));
        const columnWidth = Math.floor(width / columnCount);
        const rowCount = Math.ceil(voiceList.length / columnCount);

        const cellRenderer: GridCellRenderer = ({
          columnIndex,
          key,
          rowIndex,
          style,
        }) => {
          const index = rowIndex * columnCount + columnIndex;

          const voice = voiceList[index];

          if (!voice) return null;

          return (
            <div
              key={`${key}-${index}`}
              style={style}
              className={styles.grid_item_wrapper}
            >
              <VirtualizedVoiceCard
                model={voice}
                handleVoiceModelClick={handleVoiceModelClick}
              />
            </div>
          );
        };
        return (
          <Grid
            key={`grid-${voiceList.length}-${columnCount}`}
            className={styles.grid}
            cellRenderer={cellRenderer}
            columnCount={columnCount}
            columnWidth={columnWidth}
            height={
              isMobile
                ? window.innerHeight - mobileEmptyBottomSpace
                : height - desktopEmptyBottomSpace
            } // virtualized auto sized ігнорує деякі параметри layout, тому тут доводиться віднімати buffer padding, щоб контент не ховався
            rowCount={rowCount}
            rowHeight={rowHeight}
            width={width}
            onScroll={handleScroll}
            style={{
              // віртуалізація ігнорить деякі стилі із styles файлу
              overflowX: "hidden",
              overflowY: "auto",
            }}
            overscanRowCount={2}
          />
        );
      }}
    </AutoSizer>
  );
};

export default VirtualizedVoicesGrid;
